<!-- 试卷预览页面 -->
<template>
    <div class="exam-detail">
        <div class="cards app-width auto-grow" v-if="currentPaper!==null">
            <div class="paper">
                <div class="xy-center font-size22 font-medium" style="color: #2F3134">
                    {{ ExamName }}
                </div>
                <div class="paper-info font-size14 c-72777F">
                    <div>试卷总分:{{ currentPaper.TotalScore }}分</div>
                    <div>考试时间:{{ currentPaper.ExamTime ===0 ? '不限时长' : currentPaper.ExamTime + '分钟' }}</div>
                    <div>试题总量:{{ currentPaper.SubjectNum }}题</div>
                </div>
                <div class="answer-box">
                    <div v-for="(spin, index) in dataList" :key="index">
                        <div class="spin-title font-size18 font-medium">
                            {{ spin.bigNo }}、{{ spin.Content }}（共{{ spin.SubjectNum }}题，合计{{ spin.SubjectTypeScore }}分）
                        </div>
                        <div v-for="(orginObj,index) in spin.ExamPaperSubjectData" :key="index">
                            <!-- 题干 -->
                            <question :orgin-obj="orginObj"></question>
                            <!-- 单选题 -->
                            <div class="sigleSelect " v-if="orginObj.SubjectType === 1">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor" :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle' : singleItem.IsRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                             }">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content">
                                        </div>
                                    </div>
                                </div>
                                <div v-if="showAnwser" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right jf">
                                                答案：
                                                <div class="c-00B37C font-size18"
                                                     v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                     :key="index2">
                                                    <div class="" v-if="singleItem.IsRight">
                                                        <div>{{ opTab[index2] }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                </div>
                            </div>
                            <!-- 多选题 -->
                            <div class="multiSelect " v-else-if="orginObj.SubjectType === 2">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor multiple" :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle'  : singleItem.IsRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                             }">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div v-if="showAnwser" class="parsingBox">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                    </div>
                                    <div v-else class="notParsingBox">
                                    </div>
                                </div>
                            </div>
                            <!-- 填空题 -->
                            <div class="fillBlank" v-else-if="orginObj.SubjectType === 3">
                                <div v-if="showAnwser" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right ">
                                                <div style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                                                <div v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                     :key="index2">
                                                    <div v-if="singleItem.Content" v-html="singleItem.Content"></div>
                                                    <div v-else>无</div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                </div>
                            </div>
                            <!-- 判断题 -->
                            <div class="judgeTopic" v-else-if="orginObj.SubjectType === 4">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor multiple " :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle' : singleItem.IsRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                        }">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div v-if="showAnwser" class="parsingBox">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                    </div>
                                    <div v-else class="notParsingBox">

                                    </div>
                                </div>
                            </div>
                            <!-- 简答题 -->
                            <div class="shortAnswer fillBlank" v-else-if="orginObj.SubjectType === 5">
                                <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                     :key="index2">
                                </div>
                                <div v-if="false" class="confrimBtn xy-center font-size16 cursor">
                                    保存
                                </div>
                                <div v-if="showAnwser" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right ">
                                                <div style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                                                <div v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                     :key="index2">
                                                    <div v-if="singleItem.Content" v-html="singleItem.Content"></div>
                                                    <div v-else>无</div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="answer-card yx-start no-shrink">
                <div class="ans-list auto-grow">
                    <div v-for="(spin, index) in dataList" :key="index">
                        <div class="snap-title font-size16">{{ toChinesNum(index + 1) }}、{{ spin.Content }}</div>
                        <div class="ans-grid">
                            <div v-for="(orginObj,index2) in spin.ExamPaperSubjectData" :key="index2"
                                 class="ans-item xy-center cursor" :class="calcAnsClass(orginObj)">
                                <div @click="scrollToQues(orginObj.RankNum)">
                                    {{ orginObj.RankNum }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="loading xy-center" style="height: 100vh">
            <i class="el-icon-loading" style="font-size: 40px"></i>
        </div>
        <el-dialog
            title="选择试卷"
            :visible.sync="showSelectPaper"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="1000px"
            destroy-on-close
        >
            <div class="select-paper">
                <div>当前考试有多套试卷，请选择一套进行查看</div>
                <ul>
                    <li v-for="paper in papers" :key="paper.ExamPaperId">
                        <el-radio v-model="cid" :label="paper.ExamPaperId">{{ paper.ExamName }}</el-radio>
                    </li>
                </ul>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="selectPaper">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { GetExamTestInfo } from "@/api/course";
import { toChinesNum } from "@/utils";
import scroll from "scroll";
import Question from "@/components/exam/Question";
import AnswerParser from "@/components/exam/AnswerParser";
import { PreviewExamById } from "@/api/manage";

export default {
    name: "previewExam",
    components: { AnswerParser, Question },
    data() {
        return {
            ExamName: "",
            currentPaper: null,
            dataList: [],
            opTab: [],
            isHaveSubmit: true,
            showAnwser: true,
            showSelectPaper: false,
            papers: [],
            cid: ""
        }
    },
    created() {
        this.GetExamTestInfo()
        let tabs = [];
        for (let i = 0; i < 24; i++) {
            tabs.push(String.fromCharCode(65 + i))
        }
        this.opTab = tabs;
    },
    methods: {
        toChinesNum,
        async GetExamTestInfo() {
            let id = this.$route.query.id;
            try {
                const examInfo = await PreviewExamById({ id });
                const ids = examInfo.ExamInclude
                this.papers = examInfo.CustomExamPapers;
                if (this.papers.length > 1) {
                    this.showSelectPaper = true
                } else {
                    await this.loadPaper(ids[0])
                }
            } catch (err) {
                console.log(err);
                this.$message("服务器繁忙，请稍后再试！");
            }
        },
        async loadPaper(paperId) {
            try {
                const { data } = await GetExamTestInfo({
                    examId: this.$route.query.id,
                    examPaperId: paperId
                })
                this.ExamName = this.$route.query.ExamName
                this.currentPaper = data.data
                console.log(data.data);
                this.dataList = data.data.SubjectTypeData
                this.addNo(this.dataList);
            } catch (e) {
                console.log(e);
                this.$message("服务器繁忙，请稍后再试！");
            }
        },
        selectPaper() {
            if (this.cid) {
                this.showSelectPaper = false
                this.loadPaper(this.cid)
            } else {
                this.$message("请选择试卷")
            }
        },
        // 添加序号
        addNo(dataList) {
            let no = 1;
            for (let i = 0; i < dataList.length; i++) {
                dataList[i].bigNo = toChinesNum(i + 1);
                let esd = dataList[i].ExamPaperSubjectData || []
                for (let j = 0; j < esd.length; j++) {
                    dataList[i].ExamPaperSubjectData[j].RankNum = no++
                }
            }
        },
        scrollToQues(serial) {
            if (document.scrollingElement == null) return
            let que = document.getElementById("ques-" + serial)
            scroll.top(document.scrollingElement, que.offsetTop)
        },
        // 计算答题卡的class
        calcAnsClass(ques) {
            return {
                "has-ans": ques.haveDo,
                right: ques.userIsRight,
                error: [1, 2, 4].includes(ques.SubjectType) && !ques.userIsRight && ques.haveDo && this.showAnwser
            }
        }
    },
}
</script>

<style scoped lang="less">
.exam-detail {
    min-height: 100vh;

    .disabled {
        cursor: not-allowed;
    }

    .cards {
        align-items: start;
        display: flex;
        margin-top: 30px;
        position: relative;
        margin-bottom: 30px;

        .paper {
            flex-grow: 1;
            background: #FFFFFF;
            border-radius: 12px;
            padding: 30px;

            .paper-info {
                margin-top: 10px;
                display: flex;
                justify-content: center;

                div {
                    margin-left: 160px;
                }

                div:first-child {
                    margin-left: 0;
                }
            }

            .answer-box {
                .spin-title {
                    background: #F4F5F6;
                    padding-left: 30px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    line-height: 1.5;
                    margin-top: 21px;
                }

                .topics {
                    margin-top: 32px;
                    margin-left: 51px;
                    margin-right: 31px;

                    .topicItem {
                        margin-bottom: 20px;

                        .options {
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                            background: #FFFFFF;
                            border: 1px solid #E5E8EC;
                            margin-right: 10px;
                        }

                        .makeRightStyle {
                            background-color: #00B37C;
                            color: white;
                        }

                        .multiple {
                            border-radius: 6px;
                        }
                    }
                }

                .multiSelect .topics {
                    .singleActive.makeRightStyle {
                        background-color: #00B37C;
                        color: white;
                        border: 1px #00B37C solid;;
                    }
                }

                .parsingBox {
                    margin-top: 60px;
                    width: 100%;
                    border-radius: 8px;
                    border: 1px solid #E5E8EC;
                    min-height: 100px;
                    padding: 30px;
                    box-sizing: border-box;
                    font-size: 14px;

                    .showAnswerText {
                        .lfet {
                            .your {
                                margin-left: 70px;
                            }
                        }
                    }

                    .parsing {
                        .tit {
                            margin: 30px 0 20px 0;

                            .cyc {
                                width: 5px;
                                height: 5px;
                                border-radius: 50%;
                                background: #256CF4;
                                margin-right: 8px;
                            }
                        }
                    }
                }

                .notParsingBox {
                    width: 100%;
                    border-radius: 8px;
                    // min-height: 218px;
                }

                .fillBlank {

                    .fillBlankItem {
                        margin-left: 51px;
                        margin-right: 31px;

                        .fillBlanktext {
                            margin: 30px 0 20px 0;
                        }

                        ::v-deep .el-textarea__inner {
                            min-height: 100px !important;
                        }
                    }

                    .confrimBtn {
                        width: 120px;
                        height: 40px;
                        background: #EEF4FF;
                        border-radius: 8px;
                        border: 1px solid #256CF4;
                        color: #256CF4;
                        margin: 40px 0;
                    }
                }
            }
        }

        .answer-card {
            position: sticky;
            top: 30px;
            left: 0;
            width: 320px;
            height: calc(100vh - 130px); // headler70px + 上下边距共60px = 130px
            background: #FFFFFF;
            border-radius: 12px;
            margin-left: 30px;

            .ans-list {
                overflow-y: auto;
                width: 100%;
                padding-bottom: 20px;

                .snap-title {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    line-height: 20px;
                    margin: 20px;
                }

                .ans-grid {
                    justify-content: center;
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    gap: 20px;
                    padding: 0 19px;
                    justify-items: center;

                    .ans-item {
                        width: 100%;
                        height: 0;
                        position: relative;
                        background: #FFFFFF;
                        padding-bottom: 100%;
                        border-radius: 8px;
                        border: 1px solid #E5E8EC;
                        font-size: 16px;
                        color: #868EA1;

                        &.has-ans {
                            background: #256CF4;
                            border: 1px solid #256CF4;
                            color: white;
                        }

                        &.right {
                            background: rgb(0, 179, 124);
                            border: 1px solid rgb(0, 179, 124);
                            color: white;
                        }

                        &.error {
                            background: #F33737;
                            border: 1px solid #F33737;
                            color: white;
                        }

                        div {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .ans-item.right {
                        background: #00B37C;
                        border: 1px solid #00B37C;
                        color: white;
                    }

                    .ans-item.error {
                        background: #F7593B;
                        border: 1px solid #F7593B;
                        color: white;
                    }
                }

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    border-radius: 6px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    background: #BAC0CA;
                }
            }
        }
    }

    .select-paper {
        ul {
            padding-left: 30px;
        }

        li {
            line-height: 2;
            list-style-type: none;
        }
    }
}

</style>
